import { useEffect } from 'react';
import { User } from '../../../shared/types/generated';
import { triggerEventCustom } from '../../remote-education/remote-education-utils';
import { useSearchParams } from 'react-router-dom';
import { DOMAIN_SITE_URL } from '../../../shared/constans';

export const EventAfterTipCancel: React.FC<{
  user?: User;
  ammount?: string;
  session_id?: string;
}> = ({ user, ammount, session_id }) => {
  const [searchParams] = useSearchParams();
  const returningStripe = searchParams.get('returningStripe') || '';
  const isDonation = searchParams.get('isDonation') || '';
  const event = `{
'event': 'cancel_contribution',
'pagePath': '${DOMAIN_SITE_URL}/planes',
'price': '${ammount}',
'email': '${user?.email}',
'stripe_session_id': '${session_id}',
'userName': '${user?.name}',
}`;
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (returningStripe === 'true' && session_id && isDonation === 'true') {
        triggerEventCustom(event);
      }
    }, 800);
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [event, returningStripe, session_id, isDonation]);

  return <div></div>;
};
